import { render, staticRenderFns } from "./CategoryListSorter.vue?vue&type=template&id=6a3249be&scoped=true&"
import script from "./CategoryListSorter.vue?vue&type=script&lang=ts&"
export * from "./CategoryListSorter.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryListSorter.vue?vue&type=style&index=0&id=6a3249be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3249be",
  null
  
)

export default component.exports